/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeleteMarketingDataByMerchant$Params {
  merchantId: string;
  marketingDataId: string;
}

export function deleteMarketingDataByMerchant(http: HttpClient, rootUrl: string, params: DeleteMarketingDataByMerchant$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteMarketingDataByMerchant.PATH, 'delete');
  if (params) {
    rb.path('merchantId', params.merchantId, {});
    rb.path('marketingDataId', params.marketingDataId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteMarketingDataByMerchant.PATH = '/merchants/{merchantId}/marketing-data/{marketingDataId}';
